export type Theme = 'auto' | 'light' | 'dark' | 'sunlight';

const KEY = 'zibanu:theme';

/** The chosen theme, kept on this device (localStorage is a convenience: it may be missing). */
export function savedTheme(): Theme {
  try {
    const t = localStorage.getItem(KEY);
    return t === 'light' || t === 'dark' || t === 'sunlight' ? t : 'auto';
  } catch {
    return 'auto';
  }
}

/** "auto" follows the phone (tokens.css's prefers-color-scheme); the rest set data-theme. */
export function applyTheme(theme: Theme): void {
  if (theme === 'auto') delete document.documentElement.dataset.theme;
  else document.documentElement.dataset.theme = theme;
  try {
    if (theme === 'auto') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, theme);
  } catch {
    // Private mode: the theme still applies for this visit.
  }
}
